// SubscriptionType.js - Final version with edit mode
import React, {useEffect, useState} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';
import {
  Box,
  CircularProgress,
  Alert,
  Button,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Notify} from 'notiflix';
import {subscriptionApi} from 'api/subscriptionApi';

import SubscriptionSinglePage from 'components/Subscription/SubscriptionSinglePage';

const SubscriptionTypeContent = ({isEditMode, subscriptionId}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(isEditMode);
  const [error, setError] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);

  // Edit mode mein existing data fetch karna
  useEffect(() => {
    if (isEditMode && subscriptionId) {
      fetchSubscriptionData();
    }
  }, [isEditMode, subscriptionId]);

  const fetchSubscriptionData = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await subscriptionApi.getSubscriptionById(subscriptionId);

      setSubscriptionData(data);
    } catch (err) {
      setError(err.message || 'Failed to load subscription data');
      Notify.failure('Failed to load subscription configuration');

      // Error hone par list page par redirect
      setTimeout(() => {
        navigate('/admin/subscription-type');
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  const handleComplete = async result => {
    try {
      const {apiResponse} = result;

      Notify.success(
        apiResponse?.message ||
          (isEditMode
            ? 'Subscription configuration updated successfully!'
            : 'Subscription configuration created successfully!'),
        {
          position: 'right-top',
          timeout: 6000,
          clickToClose: true,
        },
      );

      setTimeout(() => {
        navigate('/admin/subscription-type');
      }, 1500);
    } catch (error) {
      console.error('Error in completion callback:', error);
    }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
        flexDirection="column">
        <CircularProgress />
        <Typography variant="h6" mt={2}>
          {isEditMode ? 'Loading subscription configuration...' : 'Loading...'}
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={4}>
        <Alert
          severity="error"
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => navigate('/admin/subscription-type')}>
              Back to List
            </Button>
          }>
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{width: '100%', py: 3}}>
      <Box display="flex" alignItems="center" mb={4}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/admin/subscription-type')}
          sx={{mr: 2}}>
          Back
        </Button>
        <Typography variant="h4" sx={{fontWeight: 600}}>
          {isEditMode
            ? 'Edit Subscription Type Configuration'
            : 'Create New Subscription Type Configuration'}
        </Typography>
      </Box>
      <SubscriptionSinglePage
        onComplete={handleComplete}
        onCancel={() => navigate('/admin/subscription-type')}
        initialData={isEditMode ? subscriptionData : null}
        isEditMode={isEditMode}
      />
    </Box>
  );
};

const SubscriptionType = () => {
  const {id} = useParams(); // Edit mode mein id aayega
  const navigate = useNavigate();
  const isEditMode = !!id;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SubscriptionTypeContent isEditMode={isEditMode} subscriptionId={id} />
      <Footer />
    </DashboardLayout>
  );
};

export default SubscriptionType;
